import _Object$assign from 'babel-runtime/core-js/object/assign';
import convertValue from './convertValue';
import getUnit from './getUnit';

// 约束
// var info = [
//   {
//     conditionInfos: [
//       {
//         code: 'eip_flow_out1',
//         conditionType: 'property_value',
//         value: '0',
//         valueType: 'single_float'
//       },
//       {
//         code: 'eip_flow_out2',
//         conditionType: 'property_value',
//         value: '1',
//         valueType: 'single_float'
//       }
//     ],
//     resultInfos: [
//       {
//         code: 'billing_component',
//         resultValueInfos: [
//           {
//             globalKey: 'eip_billing_component_billing_component_excludeflowout',
//             value: 'excludeflowout',
//             valueType: 'single_string'
//           }
//         ],
//         semantics: 'IN',
//         type: 'property_value',
//         unit: {
//           code: ''
//         }
//       }
//     ]
//   }
// ];
//转换成
/**
 * 约束处理，转换成如下形式：
 * {
 * a: {
 *  b: {
 *    100:[{}]
 *    101:[{}]
 * }
 * }
 * }
 * 表示a的值为100，101的时候，b的值或者取值范围
 * @export
 * @param {any} [restrictInfos=[]]  约束对象
 * @param {any} [fields=[]]  约束对象
 * @returns {Object} 约束对象
 */
export default function convertResctrictInfo(_ref) {
  var _ref$restrictInfos = _ref.restrictInfos,
      restrictInfos = _ref$restrictInfos === undefined ? [] : _ref$restrictInfos,
      _ref$fields = _ref.fields,
      fields = _ref$fields === undefined ? [] : _ref$fields;

  var allConditonItems = []; //所有条件
  //抽取条件
  restrictInfos.forEach(function (restrict) {
    var resultInfos = restrict.resultInfos,
        conditionInfos = restrict.conditionInfos;


    var conditionCodes = conditionInfos.map(function (condition) {
      return condition.code;
    });
    var conditionValues = conditionInfos.map(function (condition) {
      return condition.value;
    });

    var valueList = getValueList(resultInfos, fields);

    valueList.forEach(function (resultInfo) {
      if (resultInfo.code) {
        var _ref2, _ref3, _allConditonItems$pus;

        allConditonItems.push((_allConditonItems$pus = {}, _allConditonItems$pus['' + resultInfo.code] = (_ref3 = {}, _ref3['' + conditionCodes.join('|')] = (_ref2 = {}, _ref2['' + conditionValues.join('|')] = resultInfo.resultValueInfos, _ref2), _ref3), _allConditonItems$pus));
      }
    });
  });
  //合并条件
  return mergeConditionItems(allConditonItems);
}

function getValueList() {
  var resultInfos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fields = arguments[1];

  var valueList = [];
  resultInfos.forEach(function (resultValueInfos) {
    var cur = fields.find(function (v) {
      return v.code == resultInfos[0].code;
    });

    if (!cur) {
      return [];
    }

    var propertyUnit = getUnit(cur);
    var resultValues = convertValue({
      values: resultValueInfos.resultValueInfos,
      propertyUnit: propertyUnit,
      conversion: cur.conversion
    });
    var resultInfo = {
      code: resultInfos[0].code,
      resultValueInfos: resultValues
    };

    if (resultInfos[0].semantics === 'NOT') {
      resultInfo['resultValueInfos'] = {
        semantics: 'NOT',
        value: resultValues
      };
    }
    valueList.push(resultInfo);
  });
  return valueList;
}
function mergeConditionItems() {
  var allContditonItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var ret = {};
  allContditonItems.forEach(function (conditionItem) {
    for (var condtionCode in conditionItem) {
      var item = conditionItem[condtionCode];
      if (!ret[condtionCode]) {
        ret[condtionCode] = {};
      }
      for (var code in item) {
        if (!ret[condtionCode][code]) {
          ret[condtionCode][code] = {};
        }
        ret[condtionCode][code] = _Object$assign(ret[condtionCode][code], item[code]);
      }
    }
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/convertRestriction/index.js
// module id = 169
// module chunks = 0